// 科目系列配色：群組主色依科目在群組內的位置由深到淺變化，深色模式整體調亮以維持可讀性
const toRgb = (hex: string) => {
  const h = hex.replace('#', '');
  const n = parseInt(h.length === 3 ? h.split('').map(x => x + x).join('') : h, 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};
const toHex = (rgb: number[]) => '#' + rgb.map(v => Math.round(Math.max(0, Math.min(255, v))).toString(16).padStart(2, '0')).join('');

// 將 a 往 b 混合 t（0~1）
export const mix = (a: string, b: string, t: number) => {
  const x = toRgb(a), y = toRgb(b);
  return toHex(x.map((v, i) => v + (y[i] - v) * t));
};

const SHADES = [-0.12, 0.08, 0.26];   // 群組內第 1、2、3 張：略深、主色偏亮、更亮

// 回傳 { c: 主色（文字、色帶）, b: 淡底色（頁面背景點綴）}
export function seriesColor(base: string, index: number, dark: boolean) {
  const s = SHADES[Math.min(index, SHADES.length - 1)];
  let c = s < 0 ? mix(base, '#000000', -s) : mix(base, '#ffffff', s);
  if (dark) c = mix(c, '#ffffff', 0.3);
  const b = dark ? mix(c, '#1e293b', 0.85) : mix(c, '#ffffff', 0.92);
  return { c, b };
}
